import React from 'react'
import styled from 'styled-components'
import { B_NUM, I_NUM, N_NUM, G_NUM, O_NUM } from './CardNumbersMap'

const ControlsNumbers = styled.div`
  text-align: center;

  &.autoplay {
    pointer-events: none;
    opacity: 0.5;
  }

  label {
    &:hover {
      border: 1px dashed var(--main-color);
      background: var(--main-color-light);
      color: #fff;

      @media (hover: none) {
        border: 1px dashed #fff;
        background: none;
        color: #000;
      }
    }
  }

  span {
    input:checked + label {
      background: var(--main-color);
      color: #fff;
    }
  }

  @media (max-width: 610px) {
    display: flex;
  }

  @media print {
    display: none;
  }
`

const NumberWrap = styled.div`
  border-top: 1px solid #f1f1f1;
  border-bottom: 1px solid #f1f1f1;
  background: #f1f1f1;

  @media (max-width: 610px) {
    border: 1px solid #f1f1f1;
  }

  &:hover {
    background: #fefefe99;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;

    @media (max-width: 610px) {
      border: 1px solid #ccc;
    }

    > p {
      font-weight: bold;
    }
  }

  > p {
    width: 30px;
    padding: 5px 10px;
    display: inline-block;
    text-align: center;
    background: #dcdcdc;
    user-select: none;
    font-size: 14px;

    @media (max-width: 610px) {
      width: 100%;
      display: flex;
      justify-content: center;
    }
  }

  > span {
    input:checked + label {
      background: var(--main-color-dark);
      color: #fff;
    }

    > input {
      display: none;
    }

    label {
      font-size: 14px;
    }
  }
`

const NumberControl = styled.label`
  width: 30px;
  margin: 0 3px;
  padding: 5px;
  display: inline-block;
  border: 1px dashed #fff;
  cursor: pointer;
  text-align: center;
  user-select: none;

  @media (max-width: 400px) {
    width: 40px;
    margin: 0;
    padding: 5px;
  }
`

function CompleteNumbersBoard({ visibility, isAutoPlaying }) {
  const GENERATE_CTR_NUMBER = ({ letterMap, letter }) => (
    <NumberWrap>
      <p>{letter.toUpperCase()}</p>
      {letterMap.map((n) => (
        <span key={`ctl-${n}`}>
          <input type="checkbox" id={`ctl-${n}`} />
          <NumberControl
            htmlFor={`ctl-${n}`}
            onClick={() =>
              document
                .querySelectorAll(`.num-${n}`)
                .forEach((i) => (i.checked = !i.checked))
            }
          >{`${n}`}</NumberControl>
        </span>
      ))}
    </NumberWrap>
  )

  return (
    <ControlsNumbers
      className={`${visibility} ${isAutoPlaying ? 'autoplay' : ''}`}
    >
      {GENERATE_CTR_NUMBER({ letterMap: B_NUM, letter: 'b' })}
      {GENERATE_CTR_NUMBER({ letterMap: I_NUM, letter: 'i' })}
      {GENERATE_CTR_NUMBER({ letterMap: N_NUM, letter: 'n' })}
      {GENERATE_CTR_NUMBER({ letterMap: G_NUM, letter: 'g' })}
      {GENERATE_CTR_NUMBER({ letterMap: O_NUM, letter: 'o' })}
    </ControlsNumbers>
  )
}

export default React.memo(CompleteNumbersBoard)
